export const STARRED_TRANSCRIPT_ENTRY_PREFIX = "STARRED::";
